import React from 'react';
import { CheckCircle2Icon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { offer } from '../data/offer';
const HERO_BG = 'https://cdn.magicpatterns.com/patterns/generated-images/114e7f7c-b720-45ba-a9d4-04559571f636.jpg';
const BUNDLE = 'https://cdn.magicpatterns.com/patterns/generated-images/7c87cbfb-8768-40a4-91ec-b470735828d0.jpg';
interface HeroProps {
  variant: 'stadium' | 'bundle';
}

/** Staggered CSS entrance — no animation library needed. */
const delay = (step: number) => ({
  animationDelay: `${step * 60}ms`
});
function TrustRow() {
  return <ul className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-white/70" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-81" data-mp="sarvgui2n8e2">
      <li className="flex items-center gap-2" data-id="element-82" data-mp="nbyhl0yvhfdd">
        <span className="flex" aria-hidden="true" data-id="element-83" data-mp="3d21rlvg2wgmo">
          {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-sun text-sun" data-id="element-84" data-mp="382fern45x2ee" />)}
        </span>
        <span data-id="element-85" data-mp="384jur3fc5rv1">
          <span className="font-semibold text-white" data-id="element-86" data-mp="3j8ixl0k6uiv8">{offer.satisfaction}</span> satisfaction
          rate
        </span>
      </li>
      <li className="flex items-center gap-2" data-id="element-87" data-mp="3o7vlzpqpjxzx">
        <CheckCircle2Icon className="h-4 w-4 text-celeste-400" aria-hidden="true" data-id="element-88" data-mp="3o5j39ad4ljlt" />
        {offer.studentCount} students from Bangladesh
      </li>
      <li className="flex items-center gap-2" data-id="element-89" data-mp="3e8mur4n88xh9">
        <CheckCircle2Icon className="h-4 w-4 text-celeste-400" aria-hidden="true" data-id="element-90" data-mp="3ebisosz2rm5p" />
        7-day money-back guarantee
      </li>
    </ul>;
}
function HeroCopy({
  centered
}: {
  centered: boolean;
}) {
  return <div className={centered ? 'max-w-4xl' : 'max-w-xl'} data-id="element-91" data-mp="35aklk1tcayiw">
      <p className="rise text-[11px] font-semibold uppercase tracking-[0.22em] text-celeste-400" style={{
      fontSize: "16px",
      paddingTop: "0px",
      paddingBottom: "0px",
      textAlign: "center",
      ...delay(0)
    }} data-id="element-92" data-mp="2ql6b0qe12b1x">
          KODA ☀ DIGITAL
      </p>

      <h1 className="rise mt-5 font-display text-[2.15rem] font-extrabold leading-[1.03] tracking-tight text-white sm:text-5xl lg:text-[3.5rem]" style={delay(1)} data-id="element-93" data-mp="2lla6mq1f4hlu">
        <span className="block text-celeste-400" data-id="element-94" data-mp="s44ejdlhv3d5">Two Nations, One Soul:</span>
        <span className="block text-celeste-400" data-id="element-95" data-mp="n9qkpfmhd4al">The Secret Mindset</span>
        <span className="block text-white" data-id="element-96" data-mp="id9vei3jojvx">That Turns Hardship</span>
        <span className="block text-white" style={{
        paddingTop: "0px",
        paddingBottom: "0px"
      }} data-id="element-97" data-mp="ddf2ya44fm8r">Into World-Class Victory</span>
        <span className="mt-4 block text-[1.3rem] font-bold leading-snug text-celeste-400 sm:text-3xl lg:text-[2rem]" data-id="element-98" data-mp="1b0drfxkntnvk">
          <span className="block" style={{
          paddingTop: "0px",
          paddingBottom: "0px",
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-99" data-mp="15zq1zgc2xf3g">For decades, Argentina and Bangladesh</span>
          <span className="block" data-id="element-100" data-mp="3lsyt309hwojl">have fought from the bottom.</span>
        </span>
      </h1>

      <figure className="rise mx-auto mt-8 w-full max-w-sm sm:max-w-md lg:max-w-lg" style={delay(2)} data-id="element-101" data-mp="3lqm3c0xhx9vz">
        <img src="https://cdn.magicpatterns.com/uploads/1F54PG35zgk9PPm7PMfsdP/hf_20260828_232444_4091d97d-8cc8-4515-9b4a-3185bb5c24c9.png" alt="The Argentine Mindset complete digital system: six volumes, the main book, the bonus collection and the material shown on tablet and phone, over a night skyline of Buenos Aires and Dhaka" width={1024} height={1024} decoding="async" fetchPriority="high" className="h-auto w-full rounded-xl border border-white/15" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "0px",
        marginBottom: "0px"
      }} data-id="element-102" data-mp="3htpwlnn2mckc" />
      </figure>

      <p className="rise mt-6 max-w-2xl text-lg leading-relaxed text-white/75 sm:text-xl" style={{
      fontSize: "14px",
      paddingTop: "0px",
      paddingBottom: "0px",
      marginTop: "9px",
      marginBottom: "9px",
      width: "328px",
      height: "120px",
      ...delay(3)
    }} data-id="element-103" data-mp="2p0h6xls0j73y">
        Discover the exact mindset shift that transformed Argentina from poverty to World
        Champions — and how you can apply it to your business, freelance career, or personal
        growth <span className="font-semibold text-white" data-id="element-104" data-mp="4d7858fr7i2y">TODAY</span> (even if you&rsquo;ve
        failed before).
      </p>

      <div className="rise mt-9" style={delay(4)} data-id="element-105" data-mp="e9a5m0znusjk">
        <CtaButton size="lg" href="#volumes" label="I want to see all the content." sublabel="Instant Access · 7-Day Money-Back Guarantee" data-id="element-106" data-mp="e91vgguxa1c2" />
      </div>

      <div className="rise mt-9 border-t border-white/10 pt-6" style={{
      paddingTop: "0px",
      paddingBottom: "0px",
      ...delay(5)
    }} data-id="element-107" data-mp="3hpr202ui9b1q">
        <TrustRow data-id="element-108" data-mp="3ct0lxfipafgb" />
      </div>
    </div>;
}
export function Hero({
  variant
}: HeroProps) {
  if (variant === 'bundle') {
    return <header className="relative overflow-hidden bg-navy-950" data-id="element-109" data-mp="3mpdh6htw91d6">
        <div className="mx-auto grid max-w-content items-center gap-14 px-4 py-20 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:py-28" data-id="element-110" data-mp="3mo2c8eoppnkh">
          <HeroCopy centered={false} data-id="element-111" data-mp="2u0ppo4ijxfr6" />
          <div className="relative" data-id="element-112" data-mp="2tzmzxzwytjcu">
            <img src={BUNDLE} alt="The six volumes of The Argentine Mindset shown as ebook covers and on a tablet" width={1024} height={768} decoding="async" className="relative h-auto w-full rounded-2xl border border-white/10 object-cover" data-id="element-113" data-mp="2tylnps47qqtj" />
          </div>
        </div>
      </header>;
  }
  return <header className="relative isolate overflow-hidden bg-navy-950" data-id="element-114" data-mp="zmaq371jqj6g">
      <img src={HERO_BG} alt="" aria-hidden="true" decoding="async" fetchPriority="low" className="absolute inset-0 h-full w-full object-cover opacity-80" data-id="element-115" data-mp="14km0pjzo0xpq" />
      <div className="absolute inset-0 bg-navy-950/55" aria-hidden="true" data-id="element-116" data-mp="1x882cmpc1s9y" />
      <div className="relative mx-auto max-w-content px-4 py-24 sm:px-6 lg:py-32" style={{
      paddingTop: "8px",
      paddingBottom: "8px"
    }} data-id="element-117" data-mp="1x65fucne2h9z">
        <HeroCopy centered data-id="element-118" data-mp="1n9ai3vyxwkwr" />
      </div>
    </header>;
}